import { Button, ButtonFill, ButtonWidth, ComponentAlign, Container, FdsIcon, Icon, Orientation, Typography } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import type { Nullable } from '@tcc/common';
import styles from '../RegionReport.css';
import { LocalizedMeasurementQU, ReportMeasurement} from '../../../../types';
import { getLocalizedArea, getLocalizedAverageYield } from '../frrStatsFormat';

export type RegionReportItemsValueProps = {
  dataTestId: string;
  index: number;
  area: Nullable<ReportMeasurement>;
  averageYield: Nullable<ReportMeasurement>;
  cropCode: string;
  cropNominalWeight?: number | Nullable<ReportMeasurement>;
  onClick?: () => void;
  isArdData: boolean;
};

export const RegionReportItemsValue = ({
  averageYield,
  area,
  dataTestId,
  cropCode,
  cropNominalWeight,
  onClick,
  isArdData,
}: RegionReportItemsValueProps) => {
  const localizedArea: LocalizedMeasurementQU = getLocalizedArea(area ?? {v: 0, u: 'ha'});

  let averageYieldLocalized: LocalizedMeasurementQU | null = null;
  if(isArdData) {
    const realCropNominalWeight = (typeof cropNominalWeight === 'number' ? cropNominalWeight : (cropNominalWeight?.v ?? undefined));
    averageYieldLocalized = getLocalizedAverageYield(cropCode, averageYield ?? {v: 0, u: 'kg/ha'}, realCropNominalWeight);
  } else {
    // For non-ARD data, we just display the average yield as is, without any conversion based on crop nominal weight. This value is
    // already provided in the correct units (bu/ac) from OL. i18n is not returning the precision for the average yield,
    // so we are using toFixed(2) to ensure it is displayed with two decimal places.
    averageYieldLocalized = averageYield ? {q: averageYield.v.toFixed(2), u: averageYield.u} : null;
  }

  return (
    <Container orientation={Orientation.Horizontal} width='50%'>
      <Typography testId={`dmb-region-report-${dataTestId}-areaq`} width='50%' className={styles.alignRight}>
        {localizedArea.q}
      </Typography>
      <Container orientation={Orientation.Horizontal} width='50%' justify={ComponentAlign.End} className={styles.alignRight}>
        <Typography testId={`dmb-region-report-${dataTestId}-yieldq`}>
        { averageYieldLocalized ? averageYieldLocalized.q : '-'}
        </Typography>
        {onClick !== undefined ? (
          <Button
            fill={ButtonFill.Outline}
            iconOnly
            width={ButtonWidth.FitContent}
            onClick={onClick}
            aria-label={getMessage('details')}
            testId={`dmb-region-report-${dataTestId}-icon`}>
            <Icon icon={FdsIcon.KeyBoardArrowRight} />
          </Button>
        ) : null}
      </Container>
    </Container>
  );
};